<div class="info-message">
	<span class="freud-icon freud-icon-info-circle freud-icon-xs"></span>
	<p>{{ text }}</p>
</div>
